<template>
  <div>
    <v-card class="mt-7" flat>
      <v-card flat color="white" class="text-center">
        <v-card-title class="headline font-weight-normal primary--text">
          <v-row>
            <v-col cols="12" sm="3" md="3" class="text-left"> </v-col>

            <v-col cols="12" sm="4" md="4"> </v-col>
            <v-col cols="12" sm="5" md="5"> </v-col>
          </v-row>
        </v-card-title>
      </v-card>

      <template>
        <v-expansion-panels accordion>
          <v-expansion-panel
            v-for="(obj, i) of tableData"
            :key="i"
            class="elevation-0 info"
          >
            <v-expansion-panel-header class="py-0"
              ><v-card
                flat
                class="transparent subtitle-1 font-weight-medium primary--text text-left"
              >
                {{ obj.class }}
              </v-card>
              <v-spacer />
              <v-card
                flat
                class="transparent subtitle-1 font-weight-medium primary--text text-right mr-8"
              >
                {{
                  obj.sum.toLocaleString(undefined, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                  })
                }}
                {{ currencyApp }}
              </v-card>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-data-table
                :headers="headers"
                :items="obj.liabilities"
                item-key="i"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                hide-default-footer
              >
                <template v-slot:top> </template>

                <template v-slot:item.name="{ item }">
                  <v-btn
                    text
                    retain-focus-on-click
                    color="success"
                    class="text-capitalize ml-n4 my-n4"
                    @click="editItem(item)"
                    >{{ item.name
                    }}{{
                      item.idRelated == -1
                        ? ''
                        : ' / ' + relatedAsset(item.idRelated)
                    }}</v-btn
                  >
                </template>

                <template v-slot:item.extraPrincipal="{ item }">
                  <v-btn
                    text
                    retain-focus-on-click
                    color="success"
                    class="text-capitalize ml-n4 my-n4"
                    @click="editItemExtraPrincipal(item)"
                    >Extra Principal</v-btn
                  >
                </template>

                <template v-slot:item.balanceDueTodayLocal="{ item }">
                  <div v-if="item.currencyLocal != currencyApp">
                    <v-card-text class="my-n4"
                      >{{
                        item.balanceDueTodayLocal.toLocaleString(undefined, {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0
                        })
                      }}
                      {{ item.currencyLocal }}</v-card-text
                    >
                  </div>
                </template>

                <template v-slot:item.balanceDueTodayApp="{ item }">
                  <v-card-text class="my-n4"
                    >{{
                      item.balanceDueTodayApp.toLocaleString(undefined, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                      })
                    }}
                    {{ currencyApp }}</v-card-text
                  >
                </template>

                <template v-slot:no-data>
                  <v-card flat>
                    <v-card-text class="title font-weight-regular">
                      There are no Liabilities defined yet ...
                    </v-card-text>
                  </v-card>
                </template>
              </v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>

      <v-card flat color="white" class="text-center">
        <v-card-title class="headline font-weight-normal primary--text">
          <v-row v-if="clientLiabilitiesSum != 0">
            <v-col cols="12" sm="3" md="3" class="text-left"
              ><v-tooltip right>
                <template v-slot:activator="{ on, attrs }"
                  ><v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="success"
                    fab
                    dark
                    x-small
                    top
                    left
                    absolute
                    class="mt-8"
                    @click="dialog = !dialog"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn></template
                >
                <span>Add Liability</span>
              </v-tooltip>
            </v-col>

            <v-col cols="12" sm="4" md="4"
              ><div class="text-right">
                total:
              </div>
            </v-col>
            <v-col cols="12" sm="5" md="5"
              ><div class="text-right mr-12">
                {{
                  clientLiabilitiesSum.toLocaleString(undefined, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                  })
                }}
                {{ currencyApp }}
              </div>
            </v-col>
          </v-row>
          <v-row v-else align="center" justify="space-around">
            <v-card flat>
              <v-card-text class="title font-weight-regular">
                There are no Liabilities defined yet, let's get started
                <v-btn
                  color="success"
                  fab
                  dark
                  x-small
                  class="mb-2 ml-2"
                  @click="dialog = !dialog"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-card-text>
            </v-card>
          </v-row>
        </v-card-title>
      </v-card>
    </v-card>

    <v-dialog persistent v-model="dialog" max-width="450px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="ml-3">
            <span class="headline mt-4">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="8" md="8">
                  <v-select
                    v-if="clientAccHolderItems.length > 1"
                    v-model="liability.owner"
                    :items="clientAccHolderItems"
                    label="Liability Owner"
                    class="primary--text"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="4" md="4"> </v-col>
                <v-col cols="12" sm="8" md="8" class="mt-n8">
                  <v-select
                    v-model="liability.class"
                    :items="liabilityClassItems"
                    label="Liability class"
                    class="primary--text"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="4" md="4"> </v-col>
                <v-col cols="12" sm="8" md="8" class="mt-n8">
                  <v-select
                    v-model="liability.idRelated"
                    :items="clientAssetsName"
                    label="Related asset"
                    class="primary--text"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="4" md="4"> </v-col>

                <v-col cols="12" sm="6" md="6" class="mt-n8">
                  <v-text-field
                    v-model="liability.name"
                    :rules="nameReqRules"
                    label="Liability name"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6" class="mt-n8">
                  <v-select
                    v-model="liability.currencyLocal"
                    :items="itemsFiat"
                    label="Currency"
                    class="primary--text"
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="6" md="6" class="mt-n8">
                  <template>
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      top
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="liability.closingDate"
                          :rules="dateReqRules"
                          label="Closing date"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker"
                        v-model="liability.closingDate"
                        :max="new Date().toISOString().substr(0, 10)"
                        min="1999-01-01"
                        @change="save"
                      ></v-date-picker>
                    </v-menu>
                  </template>
                </v-col>
                <v-col cols="12" sm="6" md="6" class="mt-n8">
                  <v-text-field
                    v-model.number="liability.closingValueLocal"
                    :rules="numberReqRules"
                    :suffix="liability.currencyLocal"
                    label="Closing value"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="6" class="mt-n8">
                  <template>
                    <v-menu
                      ref="menuSec"
                      v-model="menuSec"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      top
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="liability.maturityDate"
                          :rules="dateReqRules"
                          label="Maturity date"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker"
                        v-model="liability.maturityDate"
                        max="2070-12-31"
                        :min="new Date().toISOString().substr(0, 10)"
                        @change="saveSec"
                      ></v-date-picker>
                    </v-menu>
                  </template>
                </v-col>

                <v-col cols="12" sm="6" md="6" class="mt-n8">
                  <v-text-field
                    v-model.number="liability.interestRate"
                    :rules="numberReqRules"
                    label="Interest rate"
                    suffix="% p.a."
                    class="primary--text"
                  ></v-text-field>
                </v-col>

                <!-- <v-row v-if="liability.idRelated == -1" class="mx-0">
                  <v-col cols="12" sm="12" md="12">
                    <v-checkbox
                      v-model="liability.projectionInclude"
                      :value="getRelatedAssetProjectionIncludeValue"
                      label="include this liability in projections"
                      color="success"
                      class="subtitle-1 primary--text mt-n3 mb-4"
                      hide-details
                    >
                    </v-checkbox>
                  </v-col>
                </v-row>
                <v-row v-else class="mx-0">
                  <v-col cols="12" sm="12" md="12">
                    <v-checkbox
                      v-model="liability.projectionInclude"
                      :value="getRelatedAssetProjectionIncludeValue"
                      label="include this related liability in projections"
                      color="success"
                      class="subtitle-1 primary--text mt-n3 mb-4"
                      hide-details
                      readonly
                    >
                    </v-checkbox>
                  </v-col>
                </v-row> -->

                <v-col cols="12" sm="12" md="12" class="mt-n4">
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12" sm="8" md="8" class="mt-n2 mb-2">
                  <v-select
                    v-model="liability.repaymentOption"
                    :items="repaymentItems"
                    label="Regular principal payment option"
                    class="primary--text"
                  ></v-select>
                </v-col>

                <v-row
                  v-if="liability.repaymentOption == 'principal'"
                  class="mx-0"
                >
                  <v-col cols="12" sm="6" md="6" class="mt-n10 mb-n12">
                    <v-text-field
                      v-model.number="liability.principalValueLocal"
                      label="Principal value"
                      :suffix="liability.currencyLocal"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" class="mt-n10 mb-n12">
                    <v-select
                      v-model.number="liability.period"
                      :items="itemsPeriod"
                      label="Principal period"
                      class="primary--text"
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row
                  v-if="liability.repaymentOption == 'annuity'"
                  class="mx-0"
                >
                  <v-col cols="12" sm="6" md="6" class="mt-n10 mb-n12">
                    <v-text-field
                      v-model.number="liability.annuityValueLocal"
                      label="Annuity value"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" class="mt-n10 mb-n12">
                    <v-select
                      v-model.number="liability.period"
                      :items="itemsPeriod"
                      label="Annuity period"
                      class="primary--text"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-btn class="error--text mb-4 ml-6" @click="deleteItem" text
              >Delete</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn class="primary--text mb-4" @click="close" text>Cancel</v-btn>
            <div v-if="formTitle == 'Edit Liability'">
              <v-btn
                color="success"
                :disabled="!valid"
                @click="updateItem"
                class="mr-4 mb-4"
                text
                >Update</v-btn
              >
            </div>
            <div v-else>
              <v-btn
                color="success"
                :disabled="!valid"
                @click="createItem"
                class="mr-4 mb-4"
                text
                >Create</v-btn
              >
            </div>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog persistent v-model="dialogExtraPrincipal" max-width="450px">
      <v-form ref="form" v-model="valid">
        <v-card>
          <v-card-title class="ml-3">
            <span class="headline primary--text mt-4">Extra Principal</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row v-if="liability.extraPrincipal != ''" class="mt-n4">
                <v-col cols="12" sm="12" md="12">
                  <template>
                    <v-data-table
                      :headers="headersExtraPrincipal"
                      :items="liability.extraPrincipal"
                      item-key="i"
                      :sort-by.sync="sortByExtra"
                      :sort-desc.sync="sortDescExtra"
                      hide-default-footer
                      dense
                    >
                      <template v-slot:item.date="{ item }">
                        <v-card-text class="my-n4">
                          {{ item.date }}
                        </v-card-text>
                      </template>

                      <template v-slot:item.amount="{ item }">
                        <v-card-text class="my-n4">
                          {{
                            item.amount.toLocaleString(undefined, {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0
                            })
                          }}
                          {{ liability.currencyLocal }}
                        </v-card-text>
                      </template>

                      <template v-slot:item.actions="{ item }">
                        <v-dialog
                          persistent
                          v-model="dialogConfirm"
                          max-width="250px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="success"
                              dark
                              icon
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon small class="my-n4">mdi-delete</v-icon>
                            </v-btn>
                          </template>

                          <v-card class="subtitle-1">
                            <v-card-text
                              class="subtitle-1 font-weight-medium primary--text pt-4"
                            >
                              <span
                                >Are you sure you want to delete this
                                payment?</span
                              >
                            </v-card-text>
                            <v-card-actions>
                              <v-btn
                                class="primary--text ml-2 mb-4"
                                text
                                @click="close"
                                >Cancel</v-btn
                              >
                              <v-spacer></v-spacer>
                              <v-btn
                                color="success"
                                class="mb-4"
                                text
                                @click="deleteExtraPrincipalItem(item)"
                                >OK</v-btn
                              >
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </template>

                      <template v-slot:no-data>
                        <v-card flat>
                          <v-card-text class="subtitle-1 font-weight-regular">
                            There are no extra principals yet ...
                          </v-card-text>
                        </v-card>
                      </template>
                    </v-data-table>
                  </template>
                </v-col>

                <v-col cols="12" sm="12" md="12" class="mt-n6">
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12" sm="4" md="4" class="mt-n8"> </v-col>
                <v-col cols="12" sm="6" md="6" class="mt-n8">
                  <v-card-text
                    class="subtitle-2 font-weight-medium primary--text ml-3"
                    >Total:
                    {{
                      extraPrincipalSum.toLocaleString(undefined, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                      })
                    }}
                    {{ liability.currencyLocal }}
                  </v-card-text>
                </v-col>
                <v-col cols="12" sm="2" md="2" class="mt-n8"> </v-col>

                <v-col cols="12" sm="12" md="12" class="mt-n6">
                  <v-divider class="mt-n3"></v-divider>
                </v-col>

                <v-col cols="12" sm="12" md="12" class="mt-n6">
                  <v-card-title class="ml-n4">
                    <span
                      class="subtitle-1 primary--text font-weight-medium mt-4"
                      >Add new payment</span
                    >
                  </v-card-title>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="6" md="6" class="mt-n6 mb-n12">
                  <template>
                    <v-menu
                      ref="menuTrd"
                      v-model="menuTrd"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      top
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="extraPrincipal.date"
                          :rules="dateReqRules"
                          label="Payment date"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker"
                        v-model="extraPrincipal.date"
                        :max="new Date().toISOString().substr(0, 10)"
                        :min="liability.closingDate"
                        @change="saveTrd"
                      ></v-date-picker>
                    </v-menu>
                  </template>
                </v-col>
                <v-col cols="12" sm="6" md="6" class="mt-n6 mb-n12">
                  <v-text-field
                    v-model.number="extraPrincipal.amount"
                    :rules="numberReqRules"
                    :suffix="liability.currencyLocal"
                    label="Principal amount"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="primary--text mb-4" @click="close" text>Cancel</v-btn>
            <v-btn
              color="success"
              :disabled="!valid"
              @click="createExtraPrincipalItem"
              class="mr-4 mb-4"
              text
              >Create</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import { authComputed } from '@/vuex/helpers.js'
import SystemService from '@/services/SystemService.js'
import StaticDataService from '@/services/StaticDataService.js'

export default {
  name: 'clientLedgerLiabilities',

  props: { liabilityClassItems: { type: Array } },

  data() {
    return {
      valid: true,
      dialog: false,
      dialogExtraPrincipal: false,
      dialogConfirm: false,
      menu: false,
      menuSec: false,
      menuTrd: false,
      editedId: -1,
      sortByExtra: 'date',
      sortDescExtra: true,
      sortBy: ['name', 'id'],
      sortDesc: [false, false],
      extraPrincipal: { date: SystemService.dateToday(), amount: '' },
      repaymentItems: [
        { text: 'No payment', value: 'none' },
        { text: 'Principal payment', value: 'principal' }
        // { text: 'Annuity (Principal & Interest)', value: 'annuity' }
      ],
      liability: StaticDataService.getLiability(),
      itemsFiat: StaticDataService.getUnitFiat(),
      itemsPeriod: [
        { text: 'per month', value: 12 },
        { text: 'per fortnight', value: 26 },
        { text: 'per week', value: 52 }
      ],
      headers: [
        {
          text: 'Liability Name / related Asset',
          align: 'left',
          value: 'name',
          class: 'subtitle-2 font-weight-medium primary--text'
        },
        {
          text: '',
          align: 'left',
          value: 'extraPrincipal',
          class: 'subtitle-2 font-weight-medium primary--text',
          sortable: false
        },
        {
          text: 'Balance(local)',
          align: 'right',
          value: 'balanceDueTodayLocal',
          class: 'subtitle-2 font-weight-medium primary--text',
          sortable: false
        },
        {
          text: 'Balance',
          align: 'right',
          value: 'balanceDueTodayApp',
          class: 'subtitle-2 font-weight-medium primary--text'
        }
      ],
      headersExtraPrincipal: [
        {
          text: 'Date',
          align: 'center',
          value: 'date',
          class: 'subtitle-2 font-weight-medium primary--text'
        },
        {
          text: 'Amount',
          align: 'right',
          value: 'amount',
          class: 'subtitle-2 font-weight-medium primary--text'
        },
        {
          text: 'Action',
          align: 'center',
          value: 'actions',
          class: 'subtitle-2 font-weight-medium primary--text',
          sortable: false
        }
      ],
      nameReqRules: [
        v => !!v || 'Field is required',
        v =>
          !v || (v && v.length <= 30) || 'Name must be less than 30 characters'
      ],
      numberRules: [
        v => !v || /^(?=.*\d).+$/.test(v) || 'Requires numbers only'
      ],
      numberReqRules: [
        v => !!v || 'Number is required',
        v => !v || /^(?=.*\d).+$/.test(v) || 'Requires numbers only'
      ],
      dateReqRules: [
        v => !!v || 'Date is required',
        v => !v || /^(?=.*\d).+$/.test(v) || 'Requires numbers only'
      ]
    }
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },

    menuSec(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },

    menuTrd(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },

  methods: {
    save(date) {
      this.$refs.menu.save(date)
    },

    saveSec(date) {
      this.$refs.menuSec.save(date)
    },

    saveTrd(date) {
      this.$refs.menuTrd.save(date)
    },

    createItem() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('createLiability', this.liability).then(() => {
          this.close()
        })
      }
    },

    editItem(item) {
      this.liability = Object.assign({}, item)
      this.editedId = item.id
      this.dialog = true
    },

    updateItem() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('updateLiability', this.liability).then(() => {
          this.close()
        })
      }
    },

    deleteItem() {
      this.$store.dispatch('deleteLiability', this.liability).then(() => {
        this.close()
      })
    },

    createExtraPrincipalItem() {
      if (this.$refs.form.validate()) {
        this.liability.extraPrincipal.push(this.extraPrincipal)
        this.$store.dispatch('updateLiability', this.liability).then(() => {
          ;(this.extraPrincipal = {
            date: SystemService.dateToday(),
            amount: ''
          }),
            this.close()
        })
      }
    },

    editItemExtraPrincipal(item) {
      this.liability = Object.assign({}, item)
      this.editedId = item.id
      this.dialogExtraPrincipal = true
    },

    deleteExtraPrincipalItem(item) {
      let index1 = this.liability.extraPrincipal.findIndex(obj => obj == item)
      this.liability.extraPrincipal.splice(index1, 1)
      this.$store.dispatch('updateLiability', this.liability)
      this.close()
    },

    close() {
      this.dialog = false
      this.dialogExtraPrincipal = false
      this.dialogConfirm = false
      this.liability = StaticDataService.getLiability()
      this.$refs.form.resetValidation()
      this.editedId = -1
    },

    relatedAsset(id) {
      let relatedAsset = ''
      Object.entries(this.clientAssetsName).forEach(([, name]) => {
        if (id == name.value) {
          relatedAsset = name.text
        }
      })
      return relatedAsset
    }
  },

  computed: {
    formTitle() {
      return this.editedId === -1 ? 'New Liability' : 'Edit Liability'
    },

    tableData() {
      let data = []
      let classes = []
      // get all active classes
      Object.entries(this.clientLiabilities).forEach(([, obj]) => {
        classes.push(obj.class)
      })
      let activeClasses = Array.from(new Set(classes))
      // build liability object data for drawer
      Object.entries(activeClasses).forEach(([, activeClass]) => {
        let sum = 0
        let liabilities = []
        Object.entries(this.clientLiabilities).forEach(([, obj]) => {
          if (activeClass == obj.class) {
            sum += obj.balanceDueTodayApp
            liabilities.push(obj)
          }
        })
        data.push({ class: activeClass, sum: sum, liabilities: liabilities })
      })
      data.sort(function(a, b) {
        return b.sum - a.sum
      })
      return data
    },

    extraPrincipalSum() {
      let sum = 0
      Object.entries(this.liability.extraPrincipal).forEach(([, obj]) => {
        sum += obj.amount
      })
      return sum
    },

    getRelatedAssetProjectionIncludeValue() {
      let value
      Object.entries(this.clientAssetsName).forEach(([, obj]) => {
        if (obj.value == this.liability.idRelated) {
          value = obj.projectionInclude
        }
      })
      return value
    },

    ...authComputed
  }
}
</script>

<style lang="scss" scoped></style>
